/**
 * Regular expressions
 */
export const regExp = {
    email: /^[-!#$%&'*+/=?^_{|}~A-Za-z0-9]{1,64}(?:\.[-!#$%&'*+/=?^_{|}~A-Za-z0-9]+)*@([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9]$/,
    permalink: /^(?:(?=.{6,60}$)[a-zA-Z0-9]{1}(?:(?!-{2,}))[a-zA-Z0-9-]*[a-zA-Z0-9]$)/,
    externalId: /^[a-zA-Z0-9]+$/,
    // eslint-disable-next-line no-useless-escape
    publicComment: /^[\w@\-\.:<>]+( [\w@\-\.:<>]+)*$/,
    phone: /^\+[1-9]\d{6,14}$/,
}

/**
 * Safely tests a value against a pattern that may be an invalid regular expression (e.g. backend-supplied config).
 */
export const safeTestRegExp = (pattern: string, value: string): boolean => {
    try {
        return new RegExp(pattern).test(value)
    } catch {
        return false
    }
}
